import React, { useState, useEffect } from 'react';
import { Box, Typography, Switch, FormControlLabel, useTheme } from '@mui/material';
import { useGetGlobalsQuery, useFlipDowntimeMutation } from '../../services/api';

const GlobalAddonSettings = ({ selectedCompanyId }) => {
    const theme = useTheme();
    const [isChecked, setIsChecked] = useState(false);

    const { data, isLoading: isFetching } = useGetGlobalsQuery(selectedCompanyId, {
        skip: !selectedCompanyId,
    });

    const [flipDowntime, { isLoading: isToggling }] = useFlipDowntimeMutation();

    // Fetch global addons
    useEffect(() => {
        if (data && typeof data.downtimeLog === 'boolean') {
            setIsChecked(data.downtimeLog);
        }
    }, [data]);

    // Handle toggle click
    const handleToggle = async () => {
        try {
            const res = await flipDowntime(selectedCompanyId).unwrap();
            setIsChecked(res.downtimeLog);
        } catch (error) {
            console.error('Failed to flip downtime log:', error);
        }
    };

    return (
        <Box
            mt="1rem"
            p="1.5rem"
            backgroundColor={theme.palette.background.paper}
            borderRadius="15px"
            sx={{
                boxShadow: '8px 8px 20px rgba(0, 0, 0, 0.1)',
            }}
        >
            <FormControlLabel
                sx={{ marginTop: '1rem' }}
                control={<Switch checked={isChecked} onChange={handleToggle} disabled={isToggling || isFetching} />}
                label={<Typography color={theme.palette.text.white}>Enable Downtime Log</Typography>}
            />
        </Box>
    );
};

export default GlobalAddonSettings;
